import Link from "next/link"

// Minimal footer for client-facing surfaces — compact bar, no mega columns.
// Blends with the page (bg-background) and uses adaptive text so it reads in
// both light and dark. Client-only links (no "for barbers" cross-sell).
export function ClientFooter({ className }: { className?: string }) {
  return (
    <footer className={`bg-background text-muted-foreground ${className ?? ""}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-4">
        <span className="text-[11px]">© {new Date().getFullYear()} BOOTH</span>
        <div className="flex items-center gap-4 text-[11px]">
          <Link href="/dashboard/client/account" className="hover:text-foreground transition-colors">Account</Link>
          <a href="mailto:contact@boothapp.co" className="hover:text-foreground transition-colors">Help</a>
        </div>
      </div>
    </footer>
  )
}
